














































































































































































import { Component, Vue } from "vue-property-decorator";
import { api } from "@/api";
import { appName } from "@/env";
import { readLoginError } from "@/store/main/getters";
import { dispatchSendToken, dispatchLogIn, dispatchGetAppInfo } from "@/store/main/actions";
import pkg from "../../package.json";

@Component
export default class Token extends Vue {
  public mobile = "";
  public email = "";
  public password = "";
  public appName = appName;
  public version = pkg.version;

  public loading = false;

  public get loginError() {
    console.log("login error");
    if (readLoginError(this.$store) == true) this.loading = false;
    return readLoginError(this.$store);
  }

  public submit(event) {
    this.loading = true;

    event.preventDefault();
    dispatchSendToken(this.$store, {
      mobile: this.mobile,
    });
  }
  public submitEmail(event) {
    this.loading = true;

    event.preventDefault();
    dispatchLogIn(this.$store, {
      username: this.email,
      password: this.password,
    });
  }

  public async mounted(){
    // check version
    const appInfo = await dispatchGetAppInfo(this.$store);
    const currentVersion = appInfo.data.latest_vue_app_version
    console.log("app version"+this.version)
    console.log("current version"+currentVersion)
    if (currentVersion > this.version){
      this.$forceUpdate();
      window.location.reload(true)
    }

  }
}
